// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AccountTermsModel } from "@store/Framework/Services/AccountService";

export const getAccountTermsForCustomer = (state: ApplicationState): AccountTermsModel => {
    const billToId = state.context.session.billToId;
    const storeAccountState = state.store.data.account;
    const { currentAccountId, currentTermsUrl, nextTermsUrl } = storeAccountState;
    if (billToId === currentAccountId) {
        return { currentTermsUrl, nextTermsUrl };
    }
    return { currentTermsUrl: undefined, nextTermsUrl: undefined };
};
export const isAccountTermsLoading = (state: ApplicationState): boolean => {
    const storeAccountState = state.store.data.account;
    return storeAccountState.isLoading;
};
export const isAccountTermsLoadingPriceList = (state: ApplicationState): boolean => {
    const storeAccountState = state.store.data.account;
    return storeAccountState.isLoadingPriceList;
};
